import './loading-screen.css';

/**
 * Full-screen branded loading fallback for global/Suspense states.
 */
const LoadingScreen = () => {
  return (
    <div className="ls-root ls-theme">
      <span style={{ color: '#ffffff' }}>Đang tải...</span>
    </div>
  );
};

export default LoadingScreen;
